import loadable from "@loadable/component"
import { Navigate, RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"
import { useUserInfo } from "~/store/user/userSlice"

const AnalyticsPage = loadable(async () => import("./AnalyticsPage"))

const SuperAdminAnalyticsRoute = () => {
  const { user } = useUserInfo()
  return user?.user?.roles?.some((role) => String(role) === "SuperAdmin") ? (
    <AnalyticsPage />
  ) : (
    <Navigate replace to={APP_ROUTES.home} />
  )
}

export const analyticsRoutes: RouteObject[] = [
  { path: APP_ROUTES.analytics, element: <SuperAdminAnalyticsRoute /> },
]
